import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static values = {
    origin: String,
    reflex: String,
    ajax: String,
  };

  handleConfirm(event) {
    event.preventDefault();
    // Ajouter une condition pour éviter l'exécution multiple
    event.stopImmediatePropagation(); // Ajouter une condition pour éviter l'exécution multiple

    const actionUrl = event.currentTarget.dataset.actionUrl; // URL d'action
    const confirmMessage = event.currentTarget.dataset.confirmMessage;
    const httpMethod = event.currentTarget.dataset.httpMethod || "get"; // Méthode HTTP (par défaut : GET)
    const closestSelector = event.currentTarget.dataset.closest; // "form" pour chercher le plus proche
    const formId = event.currentTarget.dataset.formId; // ID d'un formulaire spécifique
    const reflexAction = event.currentTarget.dataset.reflex; // Reflex Stimulus
    const app = event.currentTarget.dataset.app;
    const user = event.currentTarget.dataset.user;
    const recordId = event.currentTarget.dataset.id;

    // Déterminer quel formulaire utiliser
    let form = null;
    if (formId) {
      form = document.getElementById(formId); // Trouver un formulaire par ID
    } else if (closestSelector) {
      form = event.currentTarget.closest(closestSelector); // Trouver le formulaire le plus proche
    }

    // Ouvrir Fancybox
    Fancybox.show([
      {
        src: `
          <div class="fancybox-content">
            <p class="fancybox-confirm-message">${confirmMessage}</p>
            <div class="fancybox-confirm-buttons">
              <button id="fancybox-confirm-yes" class="fx-button fx-button-success">Confirmer</button>
              <button id="fancybox-confirm-no" class="fx-button fx-button-cancel">Annuler</button>
            </div>
          </div>
        `,
        type: "html",
      },
    ]);

    window.addEventListener("keydown", this.handleEscapeKey);

    // Gestion des boutons
    setTimeout(() => {
      document.getElementById("fancybox-confirm-yes").onclick = () => {
        document.activeElement.blur();
        Fancybox.close();

        if (reflexAction && recordId) {
          console.log(
            "✅ Exécution différée de Stimulus Reflex:",
            reflexAction,
            "pour ID:",
            recordId,
          );

          this.stimulate(reflexAction, recordId);

          let selectElement = document.getElementById("saved_filters");
          if (selectElement) {
            let optionToRemove = selectElement.querySelector(
              `option[value='${recordId}']`,
            );
            if (optionToRemove) {
              optionToRemove.remove();
              console.log("🗑️ Option supprimée du select :", recordId);
            }
          }
        } else {
          console.warn(
            "⚠️ Reflex non défini, fallback sur le comportement classique.",
          );

          if (form) {
            form.submit();
          } else {
            // 🟢 Sinon, on crée un formulaire temporaire
            const tempForm = document.createElement("form");
            tempForm.method = "POST";
            tempForm.action = actionUrl;

            // Ajouter un champ `_method` si nécessaire
            if (["delete", "patch", "put"].includes(httpMethod.toLowerCase())) {
              const methodInput = document.createElement("input");
              methodInput.type = "hidden";
              methodInput.name = "_method";
              methodInput.value = httpMethod.toUpperCase();
              tempForm.appendChild(methodInput);
            }

            // Ajouter le token CSRF
            const csrfToken = document.querySelector(
              'meta[name="csrf-token"]',
            )?.content;
            if (csrfToken) {
              const csrfInput = document.createElement("input");
              csrfInput.type = "hidden";
              csrfInput.name = "authenticity_token";
              csrfInput.value = csrfToken;
              tempForm.appendChild(csrfInput);
            }

            document.body.appendChild(tempForm);
            tempForm.submit();
          }
        }
      };

      document.getElementById("fancybox-confirm-no").onclick = () => {
        document.activeElement.blur();
        Fancybox.close();
      };
    }, 100);
  }

  afterReflex(element, reflex, error) {
    console.log(
      "🔥 Reflex terminé dans Fancybox, le reflex est",
      reflex,
      "Element: ",
      element,
    );

    if (reflex === "dash_setting#destroy") {
      const link = element.querySelector("a[data-id]");

      console.log("link est là ===>", link);

      if (link) {
        const id = link.dataset.id;
        const page = link.dataset.page;
        const widgetid = link.dataset.widgetid;

        document.dispatchEvent(
          new CustomEvent("dashboard:reflex-done", {
            detail: { id: id, page: page, reflex: reflex, widgetid: widgetid },
          }),
        );
      } else {
        console.warn("⚠️ Aucun élément <a> avec data-id trouvé !");
      }
    }
  }

  handleEscapeKey = (event) => {
    if (event.key === "Escape") {
      document.activeElement.blur();

      Fancybox.close();
      window.removeEventListener("keydown", this.handleEscapeKey);
    }
  };
  closeModal(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    if (window.Fancybox) {
      Fancybox.close();
    }

    const origin = this.originValue || "unknown";
    const reflex = this.reflexValue || "";
    const ajax = this.ajaxValue || "";

    console.log(`Fancybox closed from ${origin}`);
    console.log(`AJAX action: ${ajax}`);

    if (reflex) {
      console.log(`Calling Reflex: ${reflex}`);
      this.stimulate(reflex);
    }

    if (ajax) {
      console.log(`Calling AJAX: ${ajax}`);
      this.executeAjax(ajax);
    }
  }
  executeLogicOnly(event) {
    const origin = this.originValue || "unknown";
    const reflex = this.reflexValue || "";
    const ajax = this.ajaxValue || "";

    console.log(`Logic executed for modal: ${origin}`);

    // 1. Exécuter le Reflex si présent
    if (reflex) {
      console.log(`Calling Reflex: ${reflex}`);
      this.stimulate(reflex);
    }

    // 2. Exécuter l'AJAX si présent
    if (ajax) {
      console.log(`Calling AJAX: ${ajax}`);
      this.executeAjax(ajax);
    }
  }

  executeAjax(ajaxConfig) {
    try {
      const config = JSON.parse(ajaxConfig);
      const url = config.url;
      const method = config.method || "GET";
      const headers = {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          ?.content,
        ...(config.headers || {}),
      };
      const body = config.body ? JSON.stringify(config.body) : undefined;

      fetch(url, { method, headers, body })
        .then((response) => response.json())
        .then((data) => {
          //console.log("✅ AJAX Response:", data);
        })
        .catch((error) => {
          // console.error("❌ AJAX Error:", error);
        });
    } catch (err) {
      // console.error(" Invalid AJAX configuration:", err);
    }
  }
}
